import { useMemo } from 'react';
import { TextField } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { Controller, useFormContext, useWatch } from 'src/common/form';
import { FrequencyType, OperatorType } from 'src/common/enums/categorization-dashboard';
import { Frequency } from '../frequency/frequency';
import { StyledFormGroup } from '../rule/rule.styles';
import { StyledButton as FrequencyButton } from '../accordion/accordion.styles';
import { StyledButton, StyledCard, StyledRow } from './condition.styles';
import { ConditionProps } from './condition.types';
export const Condition = ({
  path,
  sources,
  handleRemove
}: ConditionProps) => {
  const {
    control,
    register,
    setValue
  } = useFormContext();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [source, field, operator, frequency] = useWatch({
    control,
    name: [`${path}.source`, `${path}.field`, `${path}.operator`, `${path}.frequency`]
  });
  const sourceOptions = useMemo(() => Object.keys(sources).map(name => ({
    label: name,
    value: name
  })), [sources]);
  const selectedSource = useMemo(() => sourceOptions.find(option => option.value === source), [source, sourceOptions]);
  const fieldOptions = useMemo(() =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  sources[source]?.map(name => ({
    label: name,
    value: name
  })) || [], [source, sources]);
  const selectedField = useMemo(() => fieldOptions.find(option => option.value === field), [field, fieldOptions]);
  const operatorOptions = useMemo(() => Object.values(OperatorType).map(type => ({
    label: type,
    value: type
  })), []);
  const selectedOperator = useMemo(() => operatorOptions.find(option => option.value === operator), [operatorOptions, operator]);
  const handleAddFrequency = () => {
    setValue(`${path}.frequency`, {
      type: FrequencyType.EVENTS
    });
  };

  // eslint-disable-next-line unicorn/no-useless-undefined
  const handleRemoveFrequency = () => setValue(`${path}.frequency`, undefined);
  return <StyledRow data-sentry-element="StyledRow" data-sentry-component="Condition" data-sentry-source-file="condition.tsx">
      <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="condition.tsx">
        <StyledRow data-sentry-element="StyledRow" data-sentry-source-file="condition.tsx">
          <StyledFormGroup data-sentry-element="StyledFormGroup" data-sentry-source-file="condition.tsx">
            <Controller control={control} name={`${path}.source`} render={({
            field: {
              onChange
            }
          }) => <TextField placeholder="Source" variant="select" isMulti={false} selected={selectedSource} isSearchable={false} options={sourceOptions} handleSelection={option => {
            onChange(option?.value);
            // eslint-disable-next-line unicorn/no-useless-undefined
            setValue(`${path}.field`, undefined);
          }} />} data-sentry-element="Controller" data-sentry-source-file="condition.tsx" />

            <Controller control={control} name={`${path}.field`} render={({
            field: {
              onChange
            }
          }) => <TextField placeholder="Field" variant="select" isMulti={false} selected={selectedField} options={fieldOptions} isSearchable handleSelection={option => onChange(option?.value)} />} data-sentry-element="Controller" data-sentry-source-file="condition.tsx" />

            <Controller control={control} name={`${path}.operator`} render={({
            field: {
              onChange
            }
          }) => <TextField variant="select" isMulti={false} selected={selectedOperator} isSearchable={false} options={operatorOptions} handleSelection={option => onChange(option?.value)} />} data-sentry-element="Controller" data-sentry-source-file="condition.tsx" />

            <TextField {...register(`${path}.value`)} data-testid="value" id="value" placeholder="Value" variant="input" isRequired maxLength={500} data-sentry-element="TextField" data-sentry-source-file="condition.tsx" />

            <StyledButton variant="outlined" color="secondary" onClick={handleRemove} data-sentry-element="StyledButton" data-sentry-source-file="condition.tsx">
              <FontAwesomeIcon icon={faTrashCan} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="condition.tsx" />
            </StyledButton>
          </StyledFormGroup>
        </StyledRow>
        {!frequency && <StyledRow>
            <StyledFormGroup>
              <FrequencyButton variant="text" color="secondary" size="small" onClick={handleAddFrequency}>
                <FontAwesomeIcon icon={faPlus} /> Add frequency
              </FrequencyButton>
            </StyledFormGroup>
          </StyledRow>}
        {frequency && <Frequency path={path} handleRemove={handleRemoveFrequency} />}
      </StyledCard>
    </StyledRow>;
};